// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@ces/XDL/types";
import { css } from "styled-components";

export const fontConfig = {
    weight: {
        regular: 400,
        bold: 700,
        black: 900,
    },
    fontFamily: "'Lato', sans-serif",
    fontSize: {
        xSmall: 12,
        small: 14,
        regular: 16,
    },
    lineHeight: {
        xSmall: "13px",
        small: "22px",
        regular: "26px",
    },
};

export default {
    fontFamilyImportUrl: "", // we will load it in HeadStart instead of PageRenderer
    body: {
        size: "16px",
        weight: fontConfig.weight.regular,
        fontFamily: fontConfig.fontFamily,
    },
    p: {
        size: "16px",
        weight: fontConfig.weight.regular,
        fontFamily: fontConfig.fontFamily,
        css: css`
            margin-bottom: 16px;
            letter-spacing: 0;
            line-height: 24px;
        `,
    },
    h1: {
        size: "32px",
        weight: fontConfig.weight.bold,
        fontFamily: fontConfig.fontFamily,
        lineHeight: "40px",
        css: css`
            margin-bottom: 24px;
            letter-spacing: 0;
        `,
    },
    h2: {
        size: "28px",
        weight: fontConfig.weight.bold,
        fontFamily: fontConfig.fontFamily,
        lineHeight: "34px",
        css: css`
            margin-bottom: 20px;
            letter-spacing: 0;
        `,
    },
    h3: {
        size: "24px",
        weight: fontConfig.weight.bold,
        fontFamily: fontConfig.fontFamily,
        lineHeight: "30px",
        css: css`
            margin-bottom: 16px;
            letter-spacing: 0;
        `,
    },
    h4: {
        size: "20px",
        weight: fontConfig.weight.bold,
        fontFamily: fontConfig.fontFamily,
        lineHeight: "26px",
        css: css`
            margin-bottom: 12px;
            letter-spacing: 0;
        `,
    },
    h5: {
        size: "18px",
        weight: fontConfig.weight.bold,
        fontFamily: fontConfig.fontFamily,
        lineHeight: "22px",
        css: css`
            margin-bottom: 12px;
            letter-spacing: 0;
        `,
    },
    h6: {
        size: "16px",
        weight: fontConfig.weight.bold,
        fontFamily: fontConfig.fontFamily,
        lineHeight: "19px",
        css: css`
            margin-bottom: 12px;
            letter-spacing: 0;
        `,
    },
    headerPrimary: {
        forwardAs: "p",
        size: "24px",
        fontFamily: fontConfig.fontFamily,
        color: "text.main",
        transform: "uppercase",
    },
    headerSecondary: {
        forwardAs: "p",
        size: "15px",
        fontFamily: fontConfig.fontFamily,
        transform: "uppercase",
        weight: fontConfig.weight.bold,
    },
    headerTertiary: {
        forwardAs: "p",
        size: "15px",
        fontFamily: fontConfig.fontFamily,
        color: "text.main",
        transform: "uppercase",
    },
    legend: {
        forwardAs: "span",
        size: "10px",
        color: "text.accent",
        transform: "uppercase",
        weight: fontConfig.weight.regular,
    },
} as xBaseTheme["typography"];
